export enum MultiplicityEnum {
    One = 'One',
    ZeroToOne = 'ZeroToOne',
    OneToMany = 'OneToMany',
    ZeroToMany = 'ZeroToMany',
}
